import { render } from "./ListadoGeneral.vue?vue&type=template&id=0765b397&scoped=true"
import script from "./ListadoGeneral.vue?vue&type=script&lang=js"
export * from "./ListadoGeneral.vue?vue&type=script&lang=js"

import "./ListadoGeneral.vue?vue&type=style&index=0&id=0765b397&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0765b397"]])

export default __exports__